import { TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState,setTotalValues } from "./defineSlice";

export default function TableCellSafetyMargin(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered, weeklyDepletionValues, selectedDepletion } = define;
   const { week1, week2, week3, week4, week5 } = weeklyDepletionValues;
   const [safetyMargin, setSafetyMargin] = useState(params.row.safetyMargin);

   useEffect(()=>{
      setSafetyMargin(params.row.safetyMargin);
   },[params.row.safetyMargin]);
   
   function updateGrid(safetyMargin, updatedQuota, w1, w2, w3, w4, w5) {
      const customerID = params.row.customerID;
      const customerGroupID = params.row.customerGroupID;
      const productGroupID = params.row.productGroupID;
      const skuid = params.row.skuid;

      let updatedItem = null;

      const updatedSafetyMargin = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if(flag === true) {
            updatedItem = {
               ...item,
               safetyMargin: safetyMargin,
               quota: updatedQuota,
               weekly1: !w1 ? 0 : w1,
               weekly2: !w2 ? 0 : w2, 
               weekly3: !w3 ? 0 : w3,
               weekly4: !w4 ? 0 : w4, 
               weekly5: !w5 ? 0 : w5
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for(let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }

      dispatch(setState("gridDataFiltered", updatedSafetyMargin));
      dispatch(setState("gridData", updatedGrid));
      dispatch(setTotalValues());
   }

   function updateSafetyMarginTemp(safetyMargin) {
      let updatedItem = null;
      const customerID = params.row.customerID;
      const customerGroupID = params.row.customerGroupID;
      const productGroupID = params.row.productGroupID;
      const skuid = params.row.skuid;

      const updatedSafetyMargin = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if(flag === true) {
            updatedItem = {
               ...item,
               safetyMargin: safetyMargin,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for(let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }

      dispatch(setState("gridDataFiltered", updatedSafetyMargin));
      dispatch(setState("gridData", updatedGrid));
   }

   function updateSafetyMargin(event) {
      let safetyMarginStr = event.target.value;
      let previousSafetyM = safetyMargin;
      if(safetyMarginStr === "0-") {
         safetyMarginStr = "-";
      }
      let safetyMgn = Number(safetyMarginStr);

      if(!isNaN(safetyMgn)) {
         setSafetyMargin(safetyMgn);
         dispatch(setState("gridDataChanged", true));
         const initialQuota = Number(params.row.initialQuota);
         const adjustment = Number(params.row.adjustment);
         const val = initialQuota === 0 ? 0 : (( safetyMgn * initialQuota ) / 100) 
         const updatedQuota = Math.round(initialQuota + val + adjustment);
   
         console.log(`Quota Calculation: ${initialQuota} + (( ${safetyMgn} * ${initialQuota} ) / 100) + ${adjustment}`);

         if(updatedQuota < 0) {
            dispatch(setState("isError", true));
            dispatch(setState("isError_Info", "Quota can not be negative."));
            if(previousSafetyM === "-"){
               const initialQuota = Number(params.row.initialQuota);
               const adjustment = Number(params.row.adjustment);
               const val = initialQuota === 0 ? 0 : (( 0 * initialQuota ) / 100)
               const updatedQuota = Math.round(initialQuota + val + adjustment);
               if(updatedQuota >= 0){
                  setSafetyMargin(0);
                  let w1 = 0;
                  let w2 = 0;
                  let w3 = 0;
                  let w4 = 0;
                  let w5 = 0;
                  if(selectedDepletion.key === "None") {
                     w1 = updatedQuota;
                  }
                  else if(selectedDepletion.key === "biweekly") {
                     w1 = Math.round(updatedQuota * week1);
                     if(w1 > updatedQuota) {
                        w1 = updatedQuota;
                     }
                     w2 = updatedQuota;
                  }
                  else if(selectedDepletion.key === "depletion_80_20"){
                     w1 = Math.round(updatedQuota * week1);
                     if(w1 > updatedQuota) {
                        w1 = updatedQuota;
                     }
                     w2 = Math.round(updatedQuota * week2);
                     if(w2 > updatedQuota) {
                        w2 = updatedQuota;
                     }
                     w3 = Math.round(updatedQuota * week3);
                     if(w3 > updatedQuota) {
                        w3 = updatedQuota;
                     }
                     w4 = Math.round(updatedQuota * week4);
                     if(w4 > updatedQuota) {
                        w4 = updatedQuota;
                     }
                     w5 = Math.round(updatedQuota * week5);
                     if(w5 !== 0){
                        w5 = updatedQuota;
                     }else{
                        w4 = updatedQuota;
                        w5 = updatedQuota;
                     }
                  }
                  else {
                     w1 = Math.round(updatedQuota * week1);
                     if(w1 > updatedQuota) {
                        w1 = updatedQuota;
                     }
                     w2 = w1 + Math.round(updatedQuota * week2);
                     if(w2 > updatedQuota) {
                        w2 = updatedQuota;
                     }
                     w3 = w2 + Math.round(updatedQuota * week3);
                     if(w3 > updatedQuota) {
                        w3 = updatedQuota;
                     }
                     w4 = w3 + Math.round(updatedQuota * week4);
                     if(w4 > updatedQuota) {
                        w4 = updatedQuota;
                     }
                     w5 = Math.round(updatedQuota * week5);
                     if(w5 !== 0){
                        w5 = updatedQuota;
                     }else{
                        w4 = updatedQuota;
                        w5 = updatedQuota;
                     }
                  }
                  updateGrid(0, updatedQuota, w1, w2, w3, w4, w5);
               }
            }else{
               setSafetyMargin(previousSafetyM);
            }
            return;
         }
   
         let w1 = 0;
         let w2 = 0;
         let w3 = 0;
         let w4 = 0;
         let w5 = 0;
         if(selectedDepletion.key === "None") {
            w1 = updatedQuota;
         }
         else if(selectedDepletion.key === "biweekly") {
            w1 = Math.round(updatedQuota * week1);
            if(w1 > updatedQuota) {
               w1 = updatedQuota;
            }
            w2 = updatedQuota;
         }
         else if(selectedDepletion.key === "depletion_80_20"){
            w1 = Math.round(updatedQuota * week1);
            if(w1 > updatedQuota) {
               w1 = updatedQuota;
            }
            w2 = Math.round(updatedQuota * week2);
            if(w2 > updatedQuota) {
               w2 = updatedQuota;
            }
            w3 = Math.round(updatedQuota * week3);
            if(w3 > updatedQuota) {
               w3 = updatedQuota;
            }
            w4 = Math.round(updatedQuota * week4);
            if(w4 > updatedQuota) {
               w4 = updatedQuota;
            }
            w5 = Math.round(updatedQuota * week5);
            if(w5 !== 0){
               w5 = updatedQuota;
            }else{
               w4 = updatedQuota;
               w5 = updatedQuota;
            }
         }
         else {
            w1 = Math.round(updatedQuota * week1);
            if(w1 > updatedQuota) {
               w1 = updatedQuota;
            }
            w2 = w1 + Math.round(updatedQuota * week2);
            if(w2 > updatedQuota) {
               w2 = updatedQuota;
            }
            w3 = w2 + Math.round(updatedQuota * week3);
            if(w3 > updatedQuota) {
               w3 = updatedQuota;
            }
            w4 = w3 + Math.round(updatedQuota * week4);
            if(w4 > updatedQuota) {
               w4 = updatedQuota;
            }
            w5 = Math.round(updatedQuota * week5);
            if(w5 !== 0){
               w5 = updatedQuota;
            }else{
               w4 = updatedQuota;
               w5 = updatedQuota;
            }
         }
         console.log("SafetyMargin", w1, w2, w3, w4, w5, updatedQuota);
         updateGrid(safetyMgn, updatedQuota, w1, w2, w3, w4, w5);

      } else if(isNaN(safetyMgn) && safetyMarginStr.length === 1) {
         dispatch(setState("gridDataChanged", true));
         updateSafetyMarginTemp(safetyMarginStr);
      }
      else {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
      }      
   }

   return (
      <TextField 
         type = "number"
         variant="standard"
         value={safetyMargin}
         onChange={updateSafetyMargin}
         inputProps={{ style: {textAlign: 'center' } }}
         sx={{
            width: 100,
            textAlign: "center",
            "& input[type = number]:: -webkit-inner-spin-button, & input[type = number]:: -webkit-outer-spin-button": {
               opacity: 1,
            }
          }}
      />
   );
}
